import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { PdfViewerComponent } from 'src/app/core/components/dialog/components/pdf-viewer/pdf-viewer.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ELABORATION_DOC_STATUS } from "../../models/elaboration-doc-status";
import { DocumentManagementService } from '../../services/document-management.service';

@Component({
  selector: 'app-document-status-card',
  templateUrl: './document-status-card.component.html',
  styleUrls: ['./document-status-card.component.css']
})
export class DocumentStatusCardComponent implements OnInit {
  @Input() id: string;
  @Input() title: string;
  @Input() date: string;
  @Input() status: string;
  @Output() onCardDelete = new EventEmitter();
  src;

  constructor(private modal : DialogService ,
    private documentService: DocumentManagementService,
    private helpersService : HelpersService,
    private domSanitizer : DomSanitizer
    ) { }

  statusEnum = ELABORATION_DOC_STATUS;


  ngOnInit() {
  }

  // ACTIONS - view - edit - delete

  onViewItem (){
    this.documentService.getDocuments(this.id)
    .pipe(map(el => el.documenti[0]))
    .subscribe((doc: DocumentoAllegato) => {
      this.helpersService.getDocumentoByIdDocumentale(doc.refDocumentale, doc.versione).subscribe(res => {
        this.src = this.domSanitizer.bypassSecurityTrustResourceUrl(res);
        console.log(this.src);
        this.modal.open(PdfViewerComponent,{data:{
           src : this.src,
            style : {
              width:"60%"
            }
          }});
      })
    })


  }

  

  onRemoveItem() {
    this.onCardDelete.emit(this.id);
  }

}
